export default __webpack_public_path__ + "192100b765bf8c47ac41340cbc965f76.png";